/**
 * A Collection of quick-reference consts for tag types.
 * Add as needed.
 */

export const ID_TAG_TYPE = {
    MOVIE: 154,
    PERSON: 214,
    TV_SHOW: 216,
    VIDEO_GAME: 222,
    STREAMING_SERVICE: 350,
    TV_SHOW_SEASON: 763,
    VIDEO_GAME_DLC: 1191,
}



// WEBPACK FOOTER //
// ./js/utils/consts/tag_type.ts